import React from 'react';

import InlinePromoBar from 'components/PlayerPromos/InlinePromoBar';
import { PromoData } from 'components/SaloonLobby/types';

import styles from './PromoStrip.module.scss';

interface PromoStripProps {
  promo: PromoData;
  onClick?: () => void;
  /** Riding in the header band (wide screens): header-height, left-aligned, no flow margins. */
  inHeader?: boolean;
}

const PromoStrip: React.FC<PromoStripProps> = ({ inHeader = false }) => {
  return (
    <div
      className={`${styles.configurablePromoSlot} ${
        inHeader ? styles.configurablePromoSlotHeader : ''
      }`}>
      <InlinePromoBar />
    </div>
  );
};

export default PromoStrip;
